var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 371,
    viewBox: "0 0 322 371",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M133.605 312.311L182.041 312.311V370.885L0.787109 370.885L174.278 0L262.943 0L323.656 122.157L323.656 370.885H254.694V312.311H303.13L218.368 117.403L133.605 312.311Z",
    fill: "#06CEA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackground);
export default __webpack_public_path__ + "static/media/auth-background.cab7b4656a9abc8c8acd2c946c577923.svg";
export { ForwardRef as ReactComponent };